"use client";

import BuildPrompt, { BuildMode } from "@/components/dashboard/build-prompt";

interface PromptInputProps {
  currentMode?: BuildMode;
  onAppCreated?: () => void;
}

// Wrapper component that uses the BuildPrompt component with default settings for Apps page
export default function PromptInput({currentMode = "Preview", onAppCreated}: PromptInputProps) {
  return (
    <BuildPrompt
      onAppCreated={onAppCreated}
      currentMode={currentMode}
      showHero={true}
      showSamplePrompts={true}
    />
  );
}
